import { NonEmptyArray } from 'shared/common/packages/JsonQuery';

export function nonEmptyArrayOr<T, F = null>(arr: T[], fallback?: F): NonEmptyArray<T> | F {
  return arr.length > 0 ? (arr as NonEmptyArray<T>) : fallback !== undefined ? fallback : (null as F);
}
